import styled from "styled-components";
import { Box, Image, Flex, Text } from "rebass/styled-components";
import { Link } from "react-router-dom";

export const StyledCommentsContainer = styled(Flex)`
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
  width: 100%;

  @media (max-width: 1500px) {
    display: none;
  }
`;

export const ViewNowMobileButton = styled(Link)`
  background-color: ${({ theme }) => theme.colors.envy};
  border-radius: 8px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.ice};
  display: none;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 24px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s ease;
  width: 100%;

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.envyDark || theme.colors.envy};
    color: ${({ theme }) => theme.colors.ice};
    text-decoration: none;
  }

  @media (max-width: 1320px) {
    display: block;
    margin: 0 auto;
    max-width: 20%;
  }

  @media (max-width: 768px) {
    max-width: none;
  }
`;

export const StyledHeaderText = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
`;

export const StyledLogoSection = styled(Flex)`
  align-items: center;
  flex-direction: column;
  max-width: 400px;
  min-width: auto;
  width: 100%;
`;

export const WidgetContainer = styled(Flex)`
  align-items: stretch;
  background-image: url("${process.env
    .REACT_APP_S3_CLIP_BUCKET}/static/web/top5/top5bg2.png");
  background-position: center;
  background-repeat: repeat;
  background-size: cover;
  border-radius: 12px;
  gap: 16px;
  height: 360px;
  justify-content: space-evenly;
  padding: 24px;
  position: relative;
  width: 100%;

  &::before {
    background: rgba(0, 0, 0, 0.4);
    border-radius: 12px;
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }

  @media (min-width: 1900px) {
    gap: 32px;
    justify-content: center;
  }

  @media (max-width: 1620px) and (min-width: 1321px) {
    height: 360px;
    padding: 20px;
  }

  @media (max-width: 1320px) and (min-width: 769px) {
    background-image: url("${process.env
      .REACT_APP_S3_CLIP_BUCKET}/static/web/top5/top5bgV.png");
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
    height: auto;
    padding: 16px;
  }

  @media (max-width: 768px) {
    background-image: url("${process.env
      .REACT_APP_S3_CLIP_BUCKET}/static/web/top5/top5bgV.png");
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
    height: auto;
    padding: 16px;
  }
`;

export const ClipSection = styled(Box)<{ $hideControlBar?: boolean }>`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  min-width: auto;

  ${({ $hideControlBar }) =>
    $hideControlBar &&
    `
      .video-js .vjs-control-bar {
        display: none;
      }
  `}

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const ViewNowButton = styled(Link)<{
  $isFullWidth?: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.envy};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.ice};
  display: block;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 24px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s ease;
  width: 200px;

  ${({ $isFullWidth }) =>
    $isFullWidth &&
    `
    box-sizing: border-box;
    width: 100%;
  `}

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.envyDark || theme.colors.envy};
    color: ${({ theme }) => theme.colors.ice};
    text-decoration: none;
  }

  @media (max-width: 1320px) {
    display: none;
  }
`;

export const ClipPlayerContainer = styled(Box)`
  aspect-ratio: 16/9;
  border-radius: 9px;
  cursor: pointer;
  height: 100%;
  max-height: 312px;
  overflow: hidden;
  position: relative;
  width: auto;

  @media (max-width: 1620px) and (min-width: 1321px) {
    max-height: 312px;
  }

  @media (max-width: 1320px) and (min-width: 769px) {
    height: auto;
    max-height: none;
    width: 100%;
  }

  @media (max-width: 768px) {
    height: auto;
    width: 100%;
  }
`;

export const StyledTop5Logo = styled(Image)`
  @media (max-width: 1320px) {
    display: none;
  }
`;
